import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import AddBlackListCustomer from "./components/addBlackListCustomers";
import Common from "../../helper/common";
import { ResultStatus } from "../../constants/appConstant";
import { Button } from "../../components/ui/button";
import AdvanceTable from "../../components/advanceTable";
import { SearchTypeEnum } from "../../constants/appConstant";
import { useAuth } from "../../contexts/auth/authContext";
import { useQueryParams } from "../../contexts/queryParamsContext";

const BlackListCustomers = () => {
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  // const [pageSize, setPageSize] = useState(null);
  const [customerId, setCustomerId] = useState();
  const [availableBookingTypes, setAvailableBookingTypes] = useState([]);
  
  const { user: authUser } = useAuth();
  const { params } = useQueryParams();
  const myClubId = params?.myClub?.id;

  useEffect(() => {
    getData(1);
  }, []);

  useEffect(() => {
    if (!open) {
      setCustomerId();
    }
  }, [open]);

  // Find club and determine available booking types
  useEffect(() => {
    if (authUser?.myClubs && myClubId) {
      global.myClub = authUser.myClubs.find((item) => item.id === myClubId);
      
      if (global.myClub) {
        // Determine available booking types based on club settings
        const bookingTypes = [];
        // Always include these two constant booking types
        bookingTypes.push(
          { key: 'appBooking', label: 'App Booking', enabled: true },
          { key: 'clubBooking', label: 'Club Booking', enabled: true }
        );
        // Add conditional booking types based on club settings
        if (global.myClub.isownapp) {
          bookingTypes.push({ key: 'myAppBooking', label: 'My App Booking', enabled: true });
        }
        if (global.myClub.isownweb) {
          bookingTypes.push({ key: 'webBooking', label: 'Web Booking', enabled: true });
        }
        if (global.myClub.isownwhatsapp) {
          bookingTypes.push({ key: 'whatsappBooking', label: 'Whatsapp Booking', enabled: true });
        }
        setAvailableBookingTypes(bookingTypes);
      }
    }
  }, [authUser, myClubId]);

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    debugger;
    const response = await Common.ApiService.getInstance().request(
      "BlackListUsers",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        recordsToDisplay,
      },
      "Post"
    );
    if (response?.data) {
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => {
          const processedItem = {
            ...item,
            phone: `${item.phoneCode ?? ""}-${item.phone ?? ""}`,
            reason: item.reason ?? "-",
            // Map booking type fields from API response - convert to "Yes"/"No" strings
            appBooking: item.appBooking ? "Yes" : "No",
            clubBooking: item.clubBooking ? "Yes" : "No",
            myAppBooking: item.myAppBooking ? "Yes" : "No",
            webBooking: item.webBooking ? "Yes" : "No",
            whatsappBooking: item.whatsappBooking ? "Yes" : "No"
          };
          return processedItem;
        }),
      };

      setData(obj);
    }
  };

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure want to delete this Black List Customer??",
      "Delete Black List Customer"
    );

    if (isConfirmed) {
      try {
        const resp = await Common.ApiService.getInstance().request(
          `DeleteBlackListUser?id=${id}`,
          {},
          "Delete"
        );

        if (resp?.status === ResultStatus.Success || resp?.message) {
          Common.SweetAlert.alert(resp.message || "Customer deleted successfully", "success");
          setTimeout(() => {
            getData(1);
          }, 500);
        } else {
          Common.SweetAlert.alert(resp?.message || "Failed to delete customer", "error");
        }
      } catch (error) {
        console.error("Delete error:", error);
        Common.SweetAlert.alert("Failed to delete customer", "error");
      }
    }
  };

  const actions = [
    {
      type: "edit",
      onClick: (val) => {
        global.log("val", val);
        setOpen(true);
        setCustomerId(val.id);
      },
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),  
    }
  ];

  // Create dynamic columns based on available booking types
  const createColumns = () => {
    const baseColumns = [
      { title: "Phone #", type: "text", key: "phone", isVisible: true },
      { title: "Reason", type: "text", key: "reason", isVisible: true },
    ];
    // Add booking type columns based on available booking types
    const bookingTypeColumns = availableBookingTypes.map(bookingType => ({
      title: bookingType.label,
      type: "text",
      key: bookingType.key,
      isVisible: true,
    }));
    return [...baseColumns, ...bookingTypeColumns];
  };

  let columns = createColumns();

  return (
    <>
      {data?.data && (
        <AdvanceTable
          title={"Black List Customers"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          addButton={() => (
            <AddBlackListCustomer
              id={customerId}
              onClose={(val) => getData()}
              open={open}
              setOpen={setOpen}
              bookingModal={false}
              availableBookingTypes={availableBookingTypes}
            />
          )}
          showPagination
          showAddButton
          actionButtons={actions}
          updateTrigger={_addUpdateTrigger}
          search={SearchTypeEnum.Server_Search}
          searchInputClassName="custom-search-mobile"
          showExportoptions
          exportFileName={"blackListCustomers"}
          // displayCount={pageSize}
        />
      )}
    </>
  );
};

export default BlackListCustomers;
